import { applyStates } from './applyStates';

// 入职邀请状态判定：邀请列表页与邀请详情页共用，避免两处逻辑漂移
export function isInviteExpired(row) {
  return Number(row.expire_time) < Math.floor(Date.now() / 1000);
}

// 已产生「已通过」的入职申请：邀请已用完，不再允许撤销
export function isInvitePassed(row) {
  return !!row.has_apply && Number(row.apply_state) === Number(applyStates.passed.value);
}

export function isInviteRejected(row) {
  return !!row.has_apply && Number(row.apply_state) === Number(applyStates.rejected.value);
}

// 驳回后是否还能让员工重新填写：邀请未撤销且未过期即可，无需重新生成链接
export function canInviteRefillAfterReject(row) {
  return !row.is_del && !isInviteExpired(row);
}

export function inviteStatusText(row) {
  if (row.is_del) return '已撤销';
  if (isInviteExpired(row)) return '已过期';
  if (row.has_apply) {
    for (const key in applyStates) {
      if (applyStates[key].value === Number(row.apply_state)) return applyStates[key].name;
    }
  }
  return '有效';
}

export function inviteStatusTag(row) {
  if (row.is_del || isInviteExpired(row)) return 'info';
  if (row.has_apply) {
    for (const key in applyStates) {
      if (applyStates[key].value === Number(row.apply_state)) {
        return applyStates[key].tagType || '';
      }
    }
  }
  return '';
}
